var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.71 17.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #1e2224;\r\n        fill-rule: evenodd;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u5F62\\u72B6",
    "data-name": "\\u5F62\\u72B6",
    className: "cls-1",
    d: "M3.68,1.72c.53-1.05,1.6-1.72,2.78-1.72h7.79c1.18,0,2.25.66,2.78,1.72l1.43,2.87c.25-.1.5-.22.75-.34.51-.26,1.13-.05,1.39.46.26.51.05,1.13-.46,1.39-.25.11-.5.22-.75.32l1,1.99c.22.43.33.91.33,1.39v2.62c0,.92-.4,1.75-1.04,2.32v1.31c0,.86-.7,1.55-1.55,1.55s-1.55-.7-1.55-1.55v-.52H4.14v.52c0,.86-.7,1.55-1.55,1.55s-1.55-.7-1.55-1.55v-1.31c-.64-.57-1.04-1.4-1.04-2.32v-2.62c0-.48.11-.96.33-1.39l.99-1.97c-.25-.11-.5-.22-.74-.34-.51-.25-.72-.88-.47-1.39.26-.51.88-.72,1.39-.46.24.12.49.23.75.34l1.43-2.87ZM7.25,10.87c0,.86-.7,1.55-1.55,1.55s-1.55-.7-1.55-1.55.7-1.55,1.55-1.55,1.55.7,1.55,1.55ZM15.01,12.42c.86,0,1.55-.7,1.55-1.55s-.7-1.55-1.55-1.55-1.55.7-1.55,1.55.7,1.55,1.55,1.55ZM5.53,2.64c.18-.35.53-.57.93-.57h7.79c.39,0,.75.22.93.57l1.31,2.63c-1.6.48-3.76.94-6.14.94s-4.53-.46-6.14-.94l1.31-2.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.449e814f6288d526727459e2047da746.svg";
export { ForwardRef as ReactComponent };